import { ErrorsType } from '@src/types/errors';

import { LoadersType } from '@modules/builders';

import { asyncActions } from './actions';
import { GETCardsResponse, POSTCardsBindResponse } from './types';

export type CardsStateType = {
  loaders: LoadersType<typeof asyncActions>;
  errors: ErrorsType;
  card: {
    number: string;
    expDate: string;
    holderName: string;
    cvv: string;
  };
  cardId?: string;
  bindId?: string;
  card3DS: {
    redirect?: POSTCardsBindResponse['redirect'];
    passed?: boolean;
  };
  list: GETCardsResponse[];
  bindStatus?: string;
};

export const initialState: CardsStateType = {
  loaders: {},
  errors: {},
  card: {
    number: '',
    expDate: '',
    holderName: '',
    cvv: '',
  },
  card3DS: {},
  list: [],
};

export default initialState;
